<template>
    <v-dialog
    v-model="show"
    persistent
    width="480">
   
    <v-card >
        <v-toolbar class="mid-font" dense >
            <v-icon left color="primary">mdi-credit-card-plus</v-icon><span class="va-underline">{{state=='new'?'Add':'Edit'}} Payment</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">
                         <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                         <v-col cols="12">
                                <div class="text-center text-h4 font-weight-bold">{{$money(payment.amount)}}</div>
                                <p class="text-center">{{$moment(payment.due_date).format('MMM DD,YYYY')}} - Amount Due</p>
                                <p class="text-center">Billing No.: {{ payment.id }}</p>
                         </v-col>

                <v-col cols="12">
                    <v-text-field
                  v-model="payment.paid_amount"
                    label="Enter Amount"
                    outlined
                     hide-details
                      :rules="textRules"
                    dense
                  required
                  ></v-text-field>
                 </v-col> 

                <v-col cols="12">
                         <v-autocomplete
                        v-model="payment.payment_method"
                        :rules="textRules"
                        hide-details
                      required
                        :items="methods"
                        outlined
                          dense
                        label="Payment Method"
                        ></v-autocomplete> 
                </v-col>
               <v-col cols="12">
                    <v-text-field
                  v-model="payment.payment_ref"
                    label="Referrence (Optional)"
                    outlined
                     hide-details
                    dense
                  required
                  ></v-text-field>
                 </v-col> 

                 <v-col cols="12">
                    <v-textarea
                  v-model="payment.remarks"
                    label="Remarks (Optional)"
                    outlined
                     hide-details
                    dense
                  required
                  ></v-textarea>
                 </v-col> 
                
              </v-row>
             </v-form>
            
          </v-card-text>
          <v-card-actions>
              <!-- <v-btn small color="error" v-if="state=='update'" @click="Remove()">
                  Remove
              </v-btn> -->
              <v-spacer/>
              <v-btn small color="secondary" @click="validate()" :loading="loading">
                  {{state=='new'?'Paid':'SAVE Changes'}} 
              </v-btn>
          </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state: {
          type: String,
          default: 'new'
      },
      data: {
          type: Object,
          default: ()=>{}
      },

  },
  data () {
      return {
        loading: false,
        valid: true,
        payment:{},
        methods:[],
         textRules: [
        v => !!v || 'Field is required'
      ],
      }
    },
  watch: {
        show(v){
            if(v){
               this.payment = this.data     
               this.methods = this.GET_SYSVARS('payment_methods')
            }
        }
  },
  computed:{
    
  },
  methods: {
      validate () {
        this.payment.paid_amount = this.$IsNum(this.payment.paid_amount)
        if(this.payment.paid_amount < this.payment.amount) {
            this.payment.remarks = "Partial Payments"
        }
        if (this.$refs.form.validate()) {
           this.Add()
        }
      },
      Add(){
            console.log(this.payment)
            this.loading = true
            this.payment.status ='paid'
          this.$http.post("make_payment", this.payment).then(response => {
              this.loading = false
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 3000)
            this.emitToParent('confirmed')
          
        }).catch(e => {
          console.log(e.data)
        })
      },
   emitToParent (action) {
    this.loading = false
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
